import { CognitoIdentityProviderStages } from '@backoffice-frontend/authentication'
import { ENV } from '@backoffice-frontend/environment'
import { useCallback, useEffect, useState } from 'react'

type Organization = {
  subdomain: string
  name: string
}

function getOrganizationsAPIUrl(): string {
  const baseUrl = CognitoIdentityProviderStages[ENV]
  return `${baseUrl}/organizations`
}

export function useOrganizations() {
  const [organizations, setOrganizations] = useState<Organization[]>([])

  const fetchOrganizations = useCallback(async () => {
    try {
      const endpoint = getOrganizationsAPIUrl()
      const response = await fetch(endpoint)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data: { organizations: Organization[] } = await response.json()
      setOrganizations(data.organizations)
    } catch (err) {
      console.error('Error fetching organizations:', err)
    }
  }, [])

  useEffect(() => {
    fetchOrganizations()
  }, [fetchOrganizations])

  return { organizations }
}
